import ArrowLeft from '../../src/legacy/ArrowLeft';
export default ArrowLeft;
